import React from 'react';
import { Space } from 'antd';
import * as S from './styles';

export function TimeStamp({ seconds, redirectClick = () => {} }) {
  return <S.Container>
    <Space>
      <S.TextCustom bold color="#24A95D">
        O próximo atendimento será carregado automaticamente em:
      </S.TextCustom>
    </Space>
    <Space
      style={{
        margin: '51px 0 29px 0',
      }}
    >
      <S.TextCustom bold color="#24A95D" size={64}>
        {`0${seconds}`}
      </S.TextCustom>
    </Space>
    <Space>
      <S.TextCustom>
        Para cancelar o carregamento automático clique no botão abaixo
      </S.TextCustom>
    </Space>
    <Space>
      <S.ButtomAction onClick={redirectClick}>
        Pausar atendimentos
      </S.ButtomAction>
    </Space>
         </S.Container>;
}
